import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Cross-feature signal used to tell the shell that the set of module views has
 * changed (e.g. a new view was created) so it can refetch the nav drawer links.
 */
@Injectable({ providedIn: 'root' })
export class ModuleViewsRefreshService {
  private readonly changed = new Subject<void>();

  get changes$(): Observable<void> {
    return this.changed.asObservable();
  }

  notifyChanged(): void {
    this.changed.next();
  }
}
